import { initializeChart } from "~/recipal-app/controllers/shared/transactions_chart";
import { onViewLoad } from "~/jose_modern/on_view_load";
import { initInventoryNameModal } from "./inventory_name_modal.js";

onViewLoad("inventories#history", () => {
  initializeChart("history-transactions-chart");
  initInventoryNameModal();
});
